export default __webpack_public_path__ + "static/media/GreenTick.71815f7e.svg";